import { Dialogs } from '@leverege/ui-elements';
import ScanSearch from "./ScanSearch.js";
import Shared from "./ScanSearchShared.js";
import Util from "./Util.js";
export default {
  ...Shared,
  id: 'search.desktop.ScanSearchAction',
  matches: {
    use: 'actionBar',
    client: ['molten.group.SearchBar', 'RelationshipTypeSelector', 'VINEditor']
  },
  perform: cxt => {
    Dialogs.show({
      id: 'scanner',
      component: ScanSearch,
      props: {
        ...cxt,
        scanAttrs: Util.getScanAttrs(cxt.context)
      }
    });
  }
};